import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import FileAttach from "../../../../../images/BrowseFiles.svg";
import Upload from "../../../../../images/Upload.svg";
import TextArea from "../../../../../stories/TextArea/TextArea";

import useAssetTableJson from "../../../../../json/useAssetTableJson";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import DeleteModal from "../../../../../customComponents/DeleteModal";

import { Keys, SpecialKeys } from "../../../../../utils/Enum.keys";
import {
  CustomModal,
  removeMoreSpace,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import { LicenseTypes, Operation } from "../../../../../utils/Enum.types";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import Assign from "./Assign";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import { useLazyQuery, useMutation } from "@apollo/client";


import useUrlParams from "../../../../../customHooks/useUrlParams";
import SubsidiarySelect from "../../../../../customComponents/SubsidiarySelect";
import {
  ItemList,
  ItemListArray,
  responseType,
} from "../../../../../utils/formTypes";

import MessageModal from "../../../../../customComponents/MessageModal";
import useEmpMasters from "../../../../../customHooks/useEmpMasters";
import { AddMrf, UpdateDraftMrf } from "./queries/mutations";
import {
  AddMrfResult,
  AddMrfVars,
  AtsMrfTrnOrderField,
  GetMrfTrnsResult,
  GetMrfTrnsVars,
  MrfTrnQueryType,
  UpdateDraftMrfResult,
  UpdateDraftMrfVars,
} from "./queries/types";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { GetSqlNumber } from "../../../../../queries/queries";
import {
  GetSqlNumberResult,
  GetSqlNumberVars,
  tableKey,
} from "../../../../../queries/types";
import {
  itmType,
  AppContext as MaterialAppContext,
} from "./statesProvider/materialContext";
import { AppContext } from "../../../../../context/context";
import { materialStatesPayloadTypes } from "./statesProvider/materialReducer";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { GetMrfTrns } from "./queries/queries";
import AddItemModal from "./AddItemModal";
import LoadingModal from "../../../../pages/LoadingModal";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import {
  GridColDef,
  GridValidRowModel,
  GridAlignment,
  GridCellParams,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import { TableHeaderProps } from "../../../../../utils/types";
import { TooltipForMultipleOption } from "../../../../../styles/TooltipStyles";
import {
  TABLE_ROW_HEIGHT,
  TOOLTIP_COLORS,
} from "../../../../../styles/Variables";
import {
  StyledDatagrid,
  useDataGridStyles,
} from "../../../../../styles/DatagridStyles";
import Navbar from "../../../../common/layout/Navbar";
import { useHotKey } from "../../../../../utils/hotKeys";
import { AtsSubsidiaryEdge } from "../../masters/subsidary/queries/types";
import useLabels from "../../../../../customHooks/useLabels";

interface totalsType {
  reqQty: number;
  approxRate: number;
  taxable: number;
  netValue: number;
  deliveryRate: number;
  installationRate: number;
  othersRate: number;
}

const Add = () => {
  const navigate = useNavigate();
  const { headerStyles } = useDataGridStyles();

  const { Purchase } = useAssetTableJson();
  const [file, setFile] = useState<File | null>(null);
  const [browse, setBrowse] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [assign, setAssign] = useState(false);
  const [addItemModal, setAddItemModal] = useState(false);

  const { customer_id, mrf_id } = useUrlParams();
  const [addOneItem, setAddOneItem] = useState(false);
  const [selectedItem, setSelectedItem] = useState<itmType | null>(null);
  const [operation, setOperation] = useState(Operation.CREATE);
  const [message, setMessage] = useState(emptyMessage);
  const { state } = useContext(AppContext);
  const { company_id } = useUrlParams();
  const { state: materialState, dispatch: materialDispatch } =
    useContext(MaterialAppContext);
  const { itemLabel } = useLabels();
  const [referenceNumber, setReferenceNumber] = useState("");
  const referenceNoRef = useRef<HTMLInputElement>(null);

  const inputs = document.getElementsByClassName("MuiOutlinedInput-input");

  const [deletedId, setDeletedId] = useState(0);

  const [items, setItems] = useState<ItemListArray[]>([]);

  const [selectedSuppliers, setSelectedSuppliers] = useState<responseType[]>(
    []
  );

  const { user_details } = useLoggedInUserDetails();

  const [mrfAddition, { loading: AddMrfLoading }] = useMutation<
    AddMrfResult,
    AddMrfVars
  >(AddMrf);

  const initialValues: ItemList = {
    approxRate: "",
    approxValue: "",
    itemId: 0,
    presentStk: "",
    priority: "",
    remarks: "",
    reqQty: "",
    tax: "",
    taxable: "",
    trnNeedBefore: "",
    udfItemDesc: "",
    uom: "",
    usedFor: "",
    deliveryRate: "",
    installationRate: "",
    otherRate: "",
    taxedValue: "",
    approxTaxableValue: "",
  };
  const { data: empDetails } = useEmpMasters(state.empId);
  const [formData, setFormData] = useState<ItemList>(initialValues);

  const [materialRequestFor, setMaterialRequestFor] =
    useState<AtsSubsidiaryEdge | null>(null);

  const [narration, setNarration] = useState("");

  const [GetMrf, { data, loading: GetSqlNumberLoading }] = useLazyQuery<
    GetSqlNumberResult,
    GetSqlNumberVars
  >(GetSqlNumber);

  const [GetTransactions, { data: transationData, loading, fetchMore }] =
    useLazyQuery<GetMrfTrnsResult, GetMrfTrnsVars>(GetMrfTrns);

  const [
    upadteTransaction,
    { data: updateMrf, loading: UpdateDraftMrfLoading },
  ] = useMutation<UpdateDraftMrfResult, UpdateDraftMrfVars>(UpdateDraftMrf, {
    onError: (e) => {
      setMessage({
        message: e.message,
        flag: true,
        operation: Operation.NONE,
      });
    },
  });

  const handleImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      let image_as_files = e.target.files[0];
      setFile(image_as_files);
    }
  };

  const { serverDate } = useServerDateandTime();

  useEffect(() => {
    if (customer_id && company_id && state.ActiveFinYr) {
      GetMrf({
        variables: {
          customerID: customer_id,
          companyID: company_id,
          
          tableKey: tableKey.MRFNO,
        },
      });
    }
  }, [GetMrf, customer_id, company_id, state.ActiveFinYr]);

  const hanldeMRFRow = (formData: ItemList, lastFunction: () => void) => {
    if (materialState.itm) {
      if (operation === Operation.UPDATE) {
        const updateItems: ItemListArray[] = items.map((itm) => {
          if (itm.itemId === formData.itemId && materialState.itm) {
            return {
              ...formData,
              approxRate: Number(formData.approxRate),
              reqQty: Number(formData.reqQty),
              tax: Number(formData.tax),
              taxable: Number(formData.taxable),
              approxValue: Number(formData.approxValue),
              presentStk: Number(formData.presentStk),
              suppliersList: materialState.selectedSuppliers,
              selectedItem: materialState.itm as itmType,
              itemId: materialState.itm ? materialState.itm.value : 0,
              preferedSupplierIds: materialState.selectedSuppliers
                .map((itm) => itm.value)
                .join(";"),
              priority: formData.priority,
              remarks: formData.remarks,
              trnNeedBefore: formData.trnNeedBefore,
              udfItemDesc: removeMoreSpace(formData.udfItemDesc),
              uom: formData.uom,
              usedFor: removeMoreSpace(formData.usedFor),
              deliveryRate: Number(formData.deliveryRate),
              installationRate: Number(formData.installationRate),
              otherRate: Number(formData.otherRate),
              taxedValue: Number(formData.taxedValue),
              approxTaxableValue: Number(formData.approxTaxableValue),
            } as ItemListArray;
          } else {
            return itm;
          }
        });
        setItems(updateItems);
        setOperation(Operation.CREATE);
        setAddOneItem(true);
        lastFunction();
      } else {
        const itmIds = items.map(({ itemId }) => itemId);
        const foundItem = itmIds.find(
          (itm_id) => materialState.itm && itm_id === materialState.itm.value
        );
        const checkBeforeData = (a: string, b: string) => {
          const date1 = new Date(a);
          const date2 = new Date(b);
          const milliseconds1 = date1.getTime();
          const milliseconds2 = date2.getTime();
          return milliseconds1 < milliseconds2;
        };

        const checkDate = checkBeforeData(formData.trnNeedBefore, serverDate);
        if (foundItem) {
          setMessage({
            flag: true,
            message: `${itemLabel} already exists`,
            operation: Operation.NONE,
          });
        } else if (formData.trnNeedBefore === "" || checkDate) {
          if (formData.trnNeedBefore === "") {
            setMessage({
              message: "Messing Need Before date",
              flag: true,
              operation: Operation.NONE,
            });
          }
          if (checkDate) {
            setMessage({
              message: "Please select a proper 'Need Before' date",
              flag: true,
              operation: Operation.NONE,
            });
          }
        } else {
          if (materialState.itm) {
            setItems([
              {
                ...formData,
                preferedSupplierIds: materialState.selectedSuppliers
                  .map(({ value }) => value)
                  .join(";"),
                reqQty: Number(formData.reqQty),
                approxRate: Number(formData.approxRate),
                taxable: Number(formData.taxable),
                tax: Number(formData.tax),
                approxValue: Number(formData.approxValue),
                presentStk: Number(formData.presentStk),
                suppliersList: materialState.selectedSuppliers,
                selectedItem: materialState.itm,
                deliveryRate: Number(formData.deliveryRate),
                installationRate: Number(formData.installationRate),
                otherRate: Number(formData.otherRate),
                taxedValue: Number(formData.taxedValue),
                approxTaxableValue: Number(formData.approxTaxableValue),
              },
              ...items,
            ]);
          }
          setMessage({
            flag: true,
            message: "Added item successfully",
            operation: Operation.CREATE,
          });
          lastFunction();
          setAddOneItem(true);
        }
      }
    }
  };

  const handleEdit = (itm: ItemListArray) => {
    setOperation(Operation.UPDATE);
    const {
      selectedItem,
      suppliersList,
      approxRate,
      approxValue,
      reqQty,
      tax,
      taxable,
      presentStk,
      trnNeedBefore,
      deliveryRate,
      installationRate,
      otherRate,
      approxTaxableValue,
      taxedValue,

      ...restForm
    } = itm;
    setSelectedItem(selectedItem);

    const approxVal = ((tax / 100) * (reqQty * approxRate)).toString();
    setFormData({
      approxRate: approxRate.toString(),
      approxValue: approxVal,
      reqQty: reqQty.toString(),
      tax: tax.toString(),
      taxable: taxable.toString(),
      presentStk: presentStk.toString(),
      trnNeedBefore: toInputStandardDate(trnNeedBefore),
      deliveryRate: deliveryRate.toString(),
      installationRate: installationRate.toString(),
      otherRate: otherRate.toString(),
      approxTaxableValue: approxTaxableValue.toString(),
      taxedValue: taxedValue.toString(),
      ...restForm,
    });
    materialDispatch({
      type: materialStatesPayloadTypes.SET_ITEM_ID,
      payload: {
        itm: selectedItem,
      },
    });
    materialDispatch({
      type: materialStatesPayloadTypes.SUPPLIERS,
      payload: {
        selectedSuppliers: suppliersList,
      },
    });
    setSelectedSuppliers(suppliersList);
    setAddItemModal(true);
  };

  const handleClear = () => {
    setFormData(initialValues);
    setSelectedSuppliers([]);
    setSelectedItem(null);
    materialDispatch({
      type: materialStatesPayloadTypes.SET_ITEM_ID,
      payload: {
        itm: null,
      },
    });
    materialDispatch({
      type: materialStatesPayloadTypes.SUPPLIERS,
      payload: {
        selectedSuppliers: [],
      },
    });
    setNarration("");
    setMaterialRequestFor(null);
    setReferenceNumber("");
  };
  const handleDelete = (id: number) => {
    setDeleteModal(!deleteModal);
    const filteredItems = items.filter(({ itemId }) => itemId !== id);
    setItems(filteredItems);
  };

  const handleSubmit = async () => {
    

    if (customer_id && state.ActiveFinYr) {
      if (!mrf_id) {
        if (items.length === 0 || !materialRequestFor) {
          if (!materialRequestFor) {
            setMessage({
              message: "Messing Material Request For",
              flag: true,
              operation: Operation.NONE,
            });
          }
          if (items.length === 0) {
            setMessage({
              message: "Messing Material item",
              flag: true,
              operation: Operation.NONE,
            });
          }
        } else {
          mrfAddition({
            variables: {
              customerId: customer_id,
              finYrId: state.ActiveFinYr.id,
              
              user_details,
              input: {
                docPath: "",
                mrfDate: toIsoDate(serverDate),
                refNo: referenceNumber,
                remarks: narration,
                subsidiaryID: materialRequestFor
                  ? materialRequestFor.node.id
                  : 0,
                itemsList: items.map((itm, index) => {
                  const {
                    suppliersList,
                    selectedItem,
                    trnNeedBefore,
                    approxValue,
                    installationRate,
                    taxedValue,
                    otherRate,
                    approxTaxableValue,
                    deliveryRate,
                    presentStk,
                    ...rest
                  } = itm;
                  return {
                    slNo: (index + 1).toString(),
                    trnNeedBefore: toIsoDate(trnNeedBefore),
                    presentStk: presentStk,
                    ...rest,
                  };
                }),
              },
            },
          }).then(({ data }) => {
            if (data && data.AddMrf) {
              setMessage({
                flag: true,
                message: "Mrf updated successfully",
                operation: Operation.CREATE,
              });
              setItems([]);
              handleClear();
            }
          });
        }
      } else {
        upadteTransaction({
          variables: {
            customerId: customer_id,
            finYrId: state.ActiveFinYr.id,
            
            mrfId: mrf_id,
            user_details,
            input: {
              docPath: "",
              mrfDate: toIsoDate(serverDate),
              refNo: referenceNumber,
              remarks: narration,
              subsidiaryID: materialRequestFor ? materialRequestFor.node.id : 0,
              itemsList: items.map((itm, index) => {
                const {
                  suppliersList,
                  selectedItem,
                  trnNeedBefore,
                  approxValue,
                  installationRate,
                  taxedValue,
                  otherRate,
                  approxTaxableValue,
                  deliveryRate,
                  ...rest
                } = itm;
                return {
                  slNo: (index + 1).toString(),
                  trnNeedBefore: toIsoDate(trnNeedBefore),
                  ...rest,
                };
              }),
            },
          },
          refetchQueries: [
            {
              query: GetMrfTrns,
              variables: {
                after: null,
                customerId: customer_id,
                finYrId: state.ActiveFinYr.id,
                first: ROWS_PER_PAGE,
                mrfId: mrf_id,
                queryType: MrfTrnQueryType.ALL_ITEMS,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsMrfTrnOrderField.SL_NO,
                },
                name: "",
                
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.UpdateDraftMrf) {
            setMessage({
              flag: true,
              message: "Mrf updated successfully",
              operation: Operation.UPDATE,
            });
          }
        });
      }
    } else {
      setMessage({
        flag: true,
        message: "Invalid credentials",
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    if (customer_id && state.ActiveFinYr && mrf_id) {
      GetTransactions({
        variables: {
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: ROWS_PER_PAGE,
          mrfId: mrf_id,
          queryType: MrfTrnQueryType.ALL_ITEMS,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfTrnOrderField.SL_NO,
          },
          name: "",
          
        },
      }).then(({ data }) => {
        if (data && data.GetMrfTrns) {
          if (data.GetMrfTrns.edges.length) {
            const mrfDetails = data.GetMrfTrns.edges[0].node;

            setMaterialRequestFor({
              node: mrfDetails.mrf.subsidiary,
              cursor: "",
            });
            setReferenceNumber(mrfDetails.mrf.refNo);
            setNarration(mrfDetails.mrf.remarks);

            const details: ItemListArray[] = data.GetMrfTrns.edges.map(
              ({ node }) => ({
                itemId: node.itemID,
                uom: node.uom,
                udfItemDesc: node.udfItemDesc,
                presentStk: node.presentStk,
                reqQty: node.reqQty,
                approxRate: node.approxRate,
                taxable: node.taxable,
                tax: node.tax,
                approxValue: node.approxValue,
                priority: node.priority,
                trnNeedBefore: node.trnNeedBefore,
                preferedSupplierIds: node.preferedSupplierIds,
                usedFor: node.usedFor,
                remarks: node.remarks,
                deliveryRate: 0,
                installationRate: 0,
                otherRate: 0,
                approxTaxableValue: 0,
                suppliersList: node.preferedSupplierDetails.map((itm) => ({
                  label: itm.desc,
                  value: itm.id,
                })),
                selectedItem: {
                  label: node.item.desc,
                  value: node.item.id,
                  code: node.item.code,
                },
                taxedValue: 0,
              })
            );
            setItems(details);
          }
        }
      });
    }
  }, [mrf_id, GetTransactions, customer_id, state.ActiveFinYr]);

  const totals = useMemo(() => {
    const totals = items.reduce(
      (acc: totalsType, item) => {
        const netVal = (item.tax / 100) * (item.reqQty * item.approxRate);
        acc.reqQty = acc.reqQty + item.reqQty;
        acc.approxRate = acc.approxRate + item.approxRate;
        acc.taxable = acc.taxable + item.approxTaxableValue;
        acc.netValue = acc.netValue + netVal;
        acc.deliveryRate = acc.deliveryRate + item.deliveryRate;
        acc.installationRate = acc.installationRate + item.installationRate;
        acc.othersRate = acc.othersRate + item.otherRate;
        return acc;
      },
      {
        reqQty: 0,
        approxRate: 0,
        netValue: 0,
        taxable: 0,
        deliveryRate: 0,
        installationRate: 0,
        othersRate: 0,
      }
    );

    return totals;
  }, [items]);

  const dynamicHeaders: TableHeaderProps[] = Purchase.Material.Add.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: (params) => {
        if (header.field === "prefered_vendor") {
          return (
            <>
              <TooltipForMultipleOption
                title={
                  <ul>
                    {params.row.prefered_vendor.map((sup: any) => {
                      return <li>{sup.label}</li>;
                    })}
                  </ul>
                }
                placement="bottom"
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: TOOLTIP_COLORS.GREY,
                      "& .MuiTooltip-arrow": {
                        color: TOOLTIP_COLORS.GREY,
                      },
                    },
                  },
                }}
              >
                <span className="material__add--tableblock--span">
                  {params.row.prefered_vendor.length}
                </span>
              </TooltipForMultipleOption>
            </>
          );
        } else if (header.field === "actions") {
          return (
            <div>
              <img
                src={Edit}
                alt=""
                onClick={() => handleEdit(params.row.actions)}
              />
              <img
                src={Delete}
                alt=""
                onClick={() => {
                  setDeletedId(params.row.itemId);
                  setDeleteModal(!deleteModal);
                }}
              />
            </div>
          );
        } else return params.value;
      },
    })
  );
  const columns: GridColDef[] = [...dynamicHeaders];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.MRF_TO_PO_ADD);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.MRF_TO_PO_ADD,
      JSON.stringify(newModel)
    );
  };
  const rows: GridValidRowModel[] =
    (items || []).map((itm, index) => {
      return {
        id: index + 1,
        item_code: itm.selectedItem.label,
        uom: itm.uom,
        description: itm.udfItemDesc,
        present_stock: itm.presentStk,
        required_qty: itm.reqQty,
        approx_rate: itm.approxRate,
        delivery_rate: itm.deliveryRate,
        installation_rate: itm.installationRate,
        others_rate: itm.otherRate,
        taxable_amt: itm.approxTaxableValue,
        tax: itm.tax,
        net_value: (itm.tax / 100) * (itm.reqQty * itm.approxRate),
        priority: itm.priority,
        need_before: toStandardDate(itm.trnNeedBefore),
        prefered_vendor: itm.suppliersList,
        used_for: itm.usedFor,
        remark: itm.remarks,
        itemId: itm.itemId,
        actions: itm,
      };
    }) || [];

  const getRow = () => {
    if (rows.length) {
      return [
        {
          id: [],
          item_code: [],
          uom: [],
          description: [],
          present_stock: "Total",
          required_qty: totals.reqQty,
          approx_rate: totals.approxRate,
          delivery_rate: totals.deliveryRate,
          installation_rate: totals.installationRate,
          others_rate: totals.othersRate,

          taxable_amt: totals.taxable,
          tax: [],
          net_value: totals.netValue,
          priority: [],
          need_before: [],
          prefered_vendor: [],
          used_for: [],
          remark: [],
          actions: [],
        },
      ];
    }
    return [];
  };
  const pinnedRows = {
    bottom: getRow(),
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "required_qty":
        case "approx_rate":
        case "taxable_amt":
        case "delivery_rate":
        case "installation_rate":
        case "others_rate":
        case "net_value":
          return "total-count";
        case "present_stock":
          return "total";
        default:
          return "hide-td";
      }
    }

    return "";
  };

  useHotKey({
    handleFunc: () => {
      setAddItemModal(!addItemModal);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.SUBSIDIARY} />
      <Title>Material Request Form</Title>
      <div className="material__add">
        <div className="material__add--filterblock row g-0">
          <div className="col material__add--filterblock--frame">
            <div className="label-grid">
              <Label>Material Request No.</Label>
              <Input
                disabled
                value={data ? data.GetSqlNumber.sqlNumber : EMPTY_STRING}
              />
              <Label>Material Request For</Label>
              <SubsidiarySelect
                onChange={(newValue) => {
                  if (newValue) {
                    setMaterialRequestFor(newValue);
                  } else {
                    setMaterialRequestFor(null);
                  }
                }}
                label=""
                autoFocus
                value={materialRequestFor ? materialRequestFor.node.id : 0}
                onKeyDown={(e) => {
                  if (e.key === Keys.ENTER) {
                    if (referenceNoRef.current) {
                      referenceNoRef.current.focus();
                    }
                  }
                }}
                companyID={company_id}
              />
              <Label>Reference No.</Label>
              <Input
                value={referenceNumber}
                inputRef={referenceNoRef}
                onChange={(e) => {
                  setReferenceNumber(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === Keys.ENTER) {
                    if (inputs.length >= 2 && inputs[2]) {
                      (inputs[2] as HTMLInputElement).focus();
                    }
                  }
                }}
              />
            </div>
          </div>
          <div className="col material__add--filterblock--frame">
            <div className="material__add--filterblock--grid">
              <Label>Date</Label>
              <Input
                type="date"
                value={toInputStandardDate(serverDate)}
                disabled
              />
            </div>
          </div>
        </div>
        <div className="row g-0">
          <div className="col flex-end">
            <Button
              mode="addnew"
              onClick={() => setAddItemModal(!addItemModal)}
            >
              {" "}
              Material {itemLabel}
            </Button>
          </div>
        </div>
        <div className="material__add--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            sx={{
              ...headerStyles,
            }}
            disableRowSelectionOnClick
            hideFooter
            pinnedRows={pinnedRows}
            getCellClassName={getCellClassName}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
          />
        </div>
        <div className="material__add--datablock">
          <div className="row g-0">
            <div className="col">
              <div className="label-grid">
                <Label>MRF Raised By</Label>
                <Input
                  disabled
                  value={empDetails ? `${empDetails.node.name}` : EMPTY_STRING}
                />
              </div>
            </div>
            <div className="col">
              <div className="label-grid">
                <Label>MRF Copy</Label>
                <div className="items__add--form--flex">
                  <Input value={file?.name} disabled />
                  {!browse ? (
                    <>
                      <label className="items__add--form--details--browse">
                        <img src={FileAttach} alt="/" className="browse-icon" />
                        Browse
                        <input
                          id="student-documents__browse--inputTag"
                          type="file"
                          className="assignment-creation__fileattach--input"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleImagePreview(e);
                            setBrowse(!browse);
                          }}
                          accept="jpg, .png, .jpeg"
                        />
                      </label>{" "}
                    </>
                  ) : (
                    <>
                      <button className="items__add--form--details--upload">
                        <img src={Upload} alt="" />
                        Upload
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="material__add--datablock--grid">
            <Label>Narration</Label>
            <TextArea
              rows={3}
              value={narration}
              onChange={(e) => {
                setNarration(e.target.value);
              }}
            />
          </div>
        </div>
        <Button mode="save" onClick={handleSubmit} />
        <Button
          mode="clear"
          onClick={() => {
            handleClear();
            setItems([]);
          }}
        />
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <DeleteModal
        id={deletedId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />
      <CustomModal
        isOpen={assign}
        onRequestClose={() => setAssign(!assign)}
        contentComponent={<Assign setModalFlag={setAssign} />}
        style={AddModalStyles}
      />
      <LoadingModal
        flag={
          loading ||
          AddMrfLoading ||
          GetSqlNumberLoading ||
          UpdateDraftMrfLoading
        }
      />
      <CustomModal
        isOpen={addItemModal}
        onRequestClose={() => setAddItemModal(!addItemModal)}
        style={AddModalStyles}
        contentComponent={
          <AddItemModal
            operation={Operation.CREATE}
            hanldeItemRow={hanldeMRFRow}
            itemsCount={items.length}
            setModal={setAddItemModal}
            addOneItemState={{
              addOneItem,
              setAddOneItem,
            }}
            formDataState={{
              formData,
              setFormData,
            }}
          />
        }
      />
    </>
  );
};

export default Add;
